import React, { Component } from 'react';
import { getIcon } from '../../util/icons';

import { NavLink } from 'react-router-dom';

class SettingsCustomSidebar extends Component{

  state = {

  }

  render(){
    return (
      <div className={`page-sidebar`}>

        <div className="sidebar-header">
          <h2>Organization Settings</h2>
        </div>

        <ul
          className="pages"
        >
          <li>
            <NavLink to={`/settings/general`}>
              <div className="page-icon">{getIcon('settings')}</div>
              <div className="page-name">General</div>
            </NavLink>
          </li>
          <li className="section-divider"></li>
            <li>
              <NavLink to={`/settings/expertise`}>
                <div className="page-icon">{getIcon('research')}</div>
                <div className="page-name">Critical Expertise</div>
              </NavLink>
            </li>
          <li>
            <NavLink to={`/settings/goals`}>
              <div className="page-icon">{getIcon('sprint')}</div>
              <div className="page-name">Sprint Goals</div>
            </NavLink>
          </li>
          <li>
            <NavLink to={`/settings/calendar`}>
              <div className="page-icon">{getIcon('calendar')}</div>
              <div className="page-name">Reporting Calendar</div>
            </NavLink>
          </li>
          {/*<li className="section-divider"></li>
          <li>
            <NavLink to={`/settings/assessmentSetup`}>
              <div className="page-icon">{getIcon('sketch')}</div>
              <div className="page-name">Assessment Setup</div>
            </NavLink>
          </li>*/}
          <li className="section-divider"></li>
          <li>
            <NavLink to={`/settings/integrations`}>
              <div className="page-icon">{getIcon('integrations')}</div>
              <div className="page-name">Integrations</div>
            </NavLink>
          </li>
        </ul>
      </div>
    )
  }
}

export default SettingsCustomSidebar;



// WEBPACK FOOTER //
// ./src/components/settings/settingsCustomSidebar.js